export const getModuleNameForAdmin = (): string[] => {
    const currentPath = window?.location?.pathname;
    let module = "";
    const splitAtModules = currentPath.split('/');
    if(splitAtModules?.length) {
        module = splitAtModules[1];
    }
    return [currentPath.replace(/^\/|\/$/g, ''), module];
}